<div class="main-content table-page table-page--compact riesgos-page">
  <div class="container-fluid">
    <ng-container *ngIf="mostrarPrincipal; else riesgosConsultaView">
      <section class="table-page__hero">
        <div class="table-page__copy">
          <h1>Riesgos de Proyecto</h1>
          <p>Seleccione un proyecto para registrar riesgos nuevos o consultar su detalle.</p>
        </div>
      </section>

      <section class="table-page__card">
        <div class="table-page__toolbar table-page__toolbar--filters">
          <div class="table-page__filters-grid">
            <mat-form-field appearance="outline" class="table-page__filter table-page__filter--wide table-page__field">
              <mat-label>Proyecto</mat-label>
              <input matInput type="text" maxlength="200" [(ngModel)]="nomProyecto"
                (keyup)="consultarProyectos(1)" autocomplete="off" aria-label="Proyecto" />
              <button *ngIf="nomProyecto" type="button" matSuffix mat-icon-button (click)="clearNombrePro()">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>

            <mat-form-field appearance="outline" class="table-page__filter table-page__filter--medium table-page__field">
              <mat-label>Cliente</mat-label>
              <mat-select [(ngModel)]="clientefl" (ngModelChange)="consultarProyectos(1)">
                <mat-option>
                  <ngx-mat-select-search [formControl]="formCliente" [placeholderLabel]="'Buscar cliente'"
                    [noEntriesFoundLabel]="'No existe cliente'">
                  </ngx-mat-select-search>
                </mat-option>
                <mat-option *ngFor="let item of listaClientes" [value]="item.id">
                  {{ item.razonsocial }}
                </mat-option>
              </mat-select>
              <button *ngIf="clientefl" type="button" matSuffix mat-icon-button (click)="clearNombreCli()">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>

            <mat-form-field appearance="outline" class="table-page__filter table-page__filter--medium table-page__field">
              <mat-label>Área</mat-label>
              <mat-select [(ngModel)]="selectArea" (selectionChange)="getArea($event.value)">
                <mat-option>
                  <ngx-mat-select-search [formControl]="formArea" [placeholderLabel]="'Buscar área'"
                    [noEntriesFoundLabel]="'No existe área'">
                  </ngx-mat-select-search>
                </mat-option>
                <mat-option *ngFor="let areaItem of (filterArea | async)" [value]="areaItem">
                  {{ areaItem.area }}
                </mat-option>
              </mat-select>
              <button *ngIf="selectArea" type="button" matSuffix mat-icon-button (click)="clearArea()">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </div>
        </div>

        <div class="table-page__table-wrap">
          <table class="table-page__table" *ngIf="projects.length > 0; else riesgosEmptyState">
            <thead>
              <tr>
                <th>Proyecto</th>
                <th>Área / Cliente</th>
                <th>Fechas</th>
                <th class="table-page__actions-head table-page__actions--multi">Acciones</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let proyecto of projects">
                <td>
                  <div class="table-page__cell-stack">
                    <strong class="table-page__name">{{ proyecto.nombre || "Sin nombre" }}</strong>
                    <span class="table-page__subtext">
                      {{ getProjectIdentifier(proyecto) }} · {{ getProjectShortName(proyecto) }}
                    </span>
                  </div>
                </td>
                <td>
                  <div class="table-page__cell-stack">
                    <span class="table-page__text">{{ proyecto.nomArea || "Sin área asignada" }}</span>
                    <span class="table-page__subtext">{{ proyecto.nombreCliente || "Sin cliente" }}</span>
                  </div>
                </td>
                <td>
                  <span class="table-page__text">{{ getDateRangeLabel(proyecto) }}</span>
                </td>
                <td class="table-page__actions table-page__actions--multi">
                  <div class="table-page__action-group">
                    <button type="button" class="table-page__action-btn" matTooltip="Agregar riesgo"
                      (click)="openModRiesgo(proyecto)">
                      <i class="material-icons">warning</i>
                    </button>
                    <button type="button" class="table-page__action-btn" matTooltip="Consultar riesgos"
                      (click)="openConsultaRiesgo(proyecto)">
                      <i class="material-icons">fact_check</i>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>

          <ng-template #riesgosEmptyState>
            <div class="table-page__empty" *ngIf="!loading; else riesgosLoadingState">
              <i class="material-icons">warning_amber</i>
              <strong>No se encontraron proyectos para gestionar riesgos</strong>
              <span>Ajusta los filtros o verifica que existan proyectos activos para el periodo actual.</span>
            </div>
          </ng-template>

          <ng-template #riesgosLoadingState>
            <div class="table-page__empty table-page__empty--loading">
              <i class="material-icons">hourglass_top</i>
              <strong>Cargando proyectos...</strong>
            </div>
          </ng-template>
        </div>

        <div class="table-page__footer" *ngIf="showPagination">
          <div class="table-page__meta">
            <span>Mostrando {{ rangeEnd }} de {{ totalRegistros }} proyectos</span>
            <span>Página {{ currentPage }} de {{ totalPages || 1 }}</span>

            <label class="table-page__page-size">
              <span>Ver:</span>
              <select [ngModel]="pageSize" (ngModelChange)="onPageSizeChange($event)">
                <option *ngFor="let option of pageSizeOptions" [ngValue]="option">{{ option }}</option>
              </select>
            </label>
          </div>

          <div class="table-page__pager" *ngIf="totalPages > 0">
            <button type="button" class="table-page__pager-link" (click)="firstPage()" [disabled]="currentPage === 1">
              Inicio
            </button>
            <button type="button" class="table-page__pager-link" (click)="previousPage()"
              [disabled]="currentPage === 1">
              Anterior
            </button>

            <ng-container *ngFor="let item of getPaginationItems()">
              <button *ngIf="isPageNumber(item); else riesgosPagerEllipsis" type="button"
                class="table-page__pager-page" [class.is-current]="item === currentPage" (click)="onPageChange(item)">
                {{ item }}
              </button>

              <ng-template #riesgosPagerEllipsis>
                <span class="table-page__pager-ellipsis">...</span>
              </ng-template>
            </ng-container>

            <button type="button" class="table-page__pager-link" (click)="nextPage()"
              [disabled]="currentPage === totalPages">
              Siguiente
            </button>
            <button type="button" class="table-page__pager-link" (click)="lastPage()"
              [disabled]="currentPage === totalPages">
              Último
            </button>
          </div>
        </div>
      </section>
    </ng-container>

    <ng-template #riesgosConsultaView>
      <app-consulta-riesgo *ngIf="mostrarConsulta" [proyectoSeleccionado]="proyectoSeleccionado!"
        (mostrarMascaraConsulta)="mostrarMascaraConsulta($event)" (mostrarPrincipal)="mostrarVistaPrincipal($event)">
      </app-consulta-riesgo>
    </ng-template>
  </div>
</div>
